import React, { useState, useEffect } from 'react';

const OfflineIndicator = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      background: 'rgba(255, 82, 82, 0.95)',
      color: 'white',
      padding: '6px 16px',
      fontSize: '0.75rem',
      fontWeight: '600',
      textAlign: 'center',
      zIndex: 2000,
      fontFamily: "'Orbitron', sans-serif",
      letterSpacing: '1px',
      textTransform: 'uppercase',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.5)',
      animation: 'slideDown 0.3s ease-out'
    }}>
      <span style={{ fontSize: '1rem' }}>⚠️</span>
      Modo Sin Conexión - Ejecutando desde memoria local (App Shell)
    </div>
  );
};

export default OfflineIndicator;
